import type { Language } from '@/bindings/Language'
import type { LocalizedText } from '@/bindings/LocalizedText'
import { LANGUAGES } from '@/lib/i18n/languages'
import { useLanguage } from '@/lib/i18n/store'

/**
 * T4.3 display chain, same as the backend's `LocalizedText::resolve`:
 * viewer → restaurant main → first filled in registry order; `undefined` when empty.
 * Values are trimmed and non-empty by construction (B3), so presence means filled.
 */
export function resolveLocalizedText(
  text: LocalizedText | null | undefined,
  viewer: Language,
  main?: Language,
): string | undefined {
  if (!text) return undefined
  if (text[viewer]) return text[viewer]
  if (main && text[main]) return text[main]
  for (const language of LANGUAGES) if (text[language]) return text[language]
  return undefined
}

/** Resolver bound to the current UI language; `main` is the restaurant's main language. */
export function useLocalizedText(main?: Language) {
  const viewer = useLanguage()
  return (text: LocalizedText | null | undefined, fallback = '') =>
    resolveLocalizedText(text, viewer, main) ?? fallback
}
